 
import CTNTable from '@ctn/ui/components/ctn-table';
import { type CTNTableRef, type CustomColumnDef } from '@ctn/ui/types/ctn-table';
import { type ForwardedRef, type ReactElement } from 'react';

import { PAGE_SIZE } from '@/constants/table.constants';
import { type ISubsanacionDocumento, type ISubsanacionSujeto } from '@/interfaces/model/don.interface';

type SubsanacionesListadoTramiteProps = {
	readonly onPageChange?: (page: number) => void;
	readonly columns: Array<CustomColumnDef<ISubsanacionDocumento | ISubsanacionSujeto>>;
	readonly isLoading?: boolean;
	readonly data: Array<ISubsanacionDocumento | ISubsanacionSujeto>;
	readonly totalData: number;
	readonly tableRef?: ForwardedRef<CTNTableRef<ISubsanacionDocumento | ISubsanacionSujeto>>;
};

const SubsanacionesListado = ({
	tableRef,
	columns,
	isLoading = false,
	data,
	totalData,
	onPageChange,
}: SubsanacionesListadoTramiteProps): ReactElement => (
	<CTNTable
		ref={tableRef}
		manualPagination
		idData="id"
		loading={isLoading}
		loadingConf={{ spinner: true }}
		columns={columns}
		data={data}
		totalData={totalData}
		manualPageCount={totalData / PAGE_SIZE.OPERACIONES}
		pageSize={PAGE_SIZE.OPERACIONES}
		className="c-pnp-table"
		onPageChange={onPageChange}
	/>
);

export default SubsanacionesListado;
